Ext.define('SA.AcsTable.TableSearchPopup', {
    alias: 'widget.acs-table-search-popup',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-acs-table-search-popup',
    plugins: [{ptype: 'sa-arrow', bias: 0.2}],

    items: [
        {
            xtype: 'acs-table-search-popup-content'
        }
    ],

    setButtonWidth(buttonWidth) {
        Array.from(this.el.dom.querySelectorAll('button'))
            .forEach(button => Ext.get(button).setWidth(buttonWidth));
    },

    setData(data) {
        this.contentCmp.setData(data);
    },

    setSizing({popupSize, buttonWidth}) {
        this.setSize(popupSize);
        this.setButtonWidth(buttonWidth);
    },

    show() {
        this.callParent();

        this.alignTo(this.alignment.cmp, this.alignment.position, this.alignment.offset);
        this.getPlugin('sa-arrow').refresh();
    }
});